import { checkPropTypes } from 'prop-types';
import React from 'react';
import classes from './index.css'
export default function CompletedCourses(props){

    var btnClass = props.showSect ? classes.btnPressed : classes.btnNotPressed
    return(
        <div 
            className= {classes.btnLvl1 + ' ' + btnClass}
            onClick={props.toggleCourses}
        >
            <h2><span className={classes.btnIcon}><i className="fas fa-graduation-cap"></i> </span> Courses </h2>
        </div>
    )
}